import { toast } from "react-toastify";
import moment from "moment";
import configs from "constants/configs";
import { Cookies } from "react-cookie";


export function getUserLogin() {
  var objUserLogin = {};
  const cookies = new Cookies();
  var token = cookies.get("userInfo");
  if (typeof token != "userInfo") {
    var arrToken = token.split("|");
    if (arrToken.length > 0) {
      objUserLogin.UserName = arrToken[2].replace("\"","");
    }
  }
  return objUserLogin;
}